var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":{ ..._vm.data, name: _vm.data.hostname },"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"hidden-keys":['status', 'brand', 'name', 'description', 'created_at', 'updated_at']}})
}
var staticRenderFns = []

export { render, staticRenderFns }